"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InsightsHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="236422" id="insights-hero" className="relative flex min-h-[80vh] items-center justify-center overflow-hidden bg-background py-40 md:py-48 text-foreground">
      
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-gray-200/65">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/uae_tech_infrastructure_pattern.png" alt="" className="h-[150%] w-auto max-w-none object-contain" aria-hidden="true" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div ref={ref} className={`mx-auto flex max-w-4xl flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <h1 className="font-default text-4xl font-bold leading-tight tracking-tight text-foreground md:text-5xl lg:text-6xl">FETC Research &amp; <br />Knowledge Center</h1>
          
          <p className="mt-6 max-w-2xl font-sans text-lg text-muted-foreground md:text-xl">Explore FETC research, expert analysis, and practical guidance on<br />&nbsp;cybersecurity, GRC, AI governance, API security,<br />threat intelligence, and digital transformation.</p>
          
          <div className="mt-36 flex w-full flex-row items-center justify-between gap-6">
            <Button asChild variant="outline" size="lg" className="ml-[-39px] h-14 rounded-md bg-transparent border-primary px-8 text-lg font-medium text-white shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:bg-primary/5">
              <Link to="/ContactUsPage">Explore Research Areas</Link>
            </Button>
            <Button variant="outline" size="lg" className="h-14 rounded-md border-primary px-8 text-lg font-medium text-white shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-lg" onClick={() => document.getElementById("insights-articles")?.scrollIntoView({
            behavior: "smooth",
            block: "start"
          })}>
              Browse All Articles
            </Button>
          </div>
        </div>
      </div>
    </section>;
}